<div class="challenge-container">
<!-- Knolli Widget Start -->
<iframe
#knolliIframe
[src]="knolliUrl"
id="knolli-embed">
</iframe>
<!-- Knolli Widget End -->
</div>
